import { useTranslation } from "react-i18next";
import support from "../../assets/support.svg";
import location from "../../assets/location1.svg";
import phone from "../../assets/phone1.svg";
import contactusImg from "../../assets/contactus.svg";
import "./style.css";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import SocialService from "../../services/SocialService";
import ContactService from "../../services/ContactService";
import { toast } from "react-toastify";
import BannerService from "../../services/BannerService";

const ContactUs = () => {
	const [data, setData] = useState({});
	const [bg, setBg] = useState("");
	const [formData, setFormData] = useState({
		full_name: "",
		email: "",
		subject: "",
		message: "",
	});
	const { t } = useTranslation();

	useEffect(() => {
		new SocialService().getList().then((res) => {
			if (res?.status === 200) {
				setData(res?.data?.data);
			}
		});
		new BannerService().getList("contact").then((res) => {
			if (res?.status) {
				let url = res?.data?.data?.banner_images;
				if (!!url?.length) {
					setBg(url[0].url);
				}
			}
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		new ContactService().create(formData).then((res) => {
			if (res?.status === 201) {
				toast.success("Message Send Successfully");
				setFormData({
					full_name: "",
					email: "",
					subject: "",
					message: "",
				});
			}
		});
	};

	return (
		<div className="main-page">
			<Helmet>
				<title>
					{t("afkar")} | {t("contact us")}
				</title>
			</Helmet>
			<div className="header" style={{ backgroundImage: `url(${bg})` }}>
				<div className="shadow"></div>
				<p className="header-title">{t("contact us")}</p>
			</div>
			<div className="contactus">
				<div className="container">
					<div className="row">
						{/* {!!data?.sales_email && (
							<div className="col-md-3 col-12" data-aos="zoom-in">
								<div className="contact-card">
									<img src={chat} alt="chat" width={40} />
									<p className="title">{t("Chat to Sales")}</p>
									<span>{t("Speak to our friendly team")}</span>
									<a href={`mailto:${data?.sales_email}`} className="data">
										{data?.sales_email}
									</a>
								</div>
							</div>
						)} */}
						{!!data?.support_email && (
							<div className="col-md-4 col-12" data-aos="zoom-in">
								<div className="contact-card">
									<img src={support} alt="support" width={40} />
									<p className="title">{t("Chat to Support")}</p>
									<span>{t("We’re here to help")}</span>
									<a href={`mailto:${data?.support_email}`} className="data">
										{data?.support_email}
									</a>
								</div>
							</div>
						)}
						{!!data?.location && (
							<div className="col-md-4 col-12" data-aos="zoom-in">
								<div className="contact-card">
									<img src={location} alt="location" width={40} />
									<p className="title">{t("Visit Us")}</p>
									<span>{t("Visit our office HQ")}</span>
									<p className="data"></p>
									<a href={data?.location} className="data">
										{t("View on Google Maps")}
									</a>
								</div>
							</div>
						)}
						<div className="col-md-4 col-12" data-aos="zoom-in">
							<div className="contact-card">
								<img src={phone} alt="phone" width={40} />
								<p className="title">{t("Call Us")}</p>
								<span>
									{data?.day_from}-{data?.day_to} {t("from")} {data?.time_from}{" "}
									{t("to")} {data?.time_to}
								</span>
								<a href={`tel:${data?.phone}`} className="data">
									{data?.phone}
								</a>
							</div>
						</div>
					</div>
					<div className="contactus-form">
						<form className="form" data-aos="flip-left" onSubmit={submit}>
							<p className="title">{t("JOIN US")}</p>
							<div className="row">
								<div className="col-md-6 mb-3">
									<label>{t("Full Name")}</label>
									<input
										type="text"
										required
										value={formData?.full_name}
										placeholder={t("Full Name")}
										onChange={(e) =>
											setFormData({ ...formData, full_name: e.target.value })
										}
									/>
								</div>
								<div className="col-md-6 mb-3">
									<label>{t("Email")}</label>
									<input
										type="email"
										required
										value={formData?.email}
										placeholder={t("Email")}
										onChange={(e) =>
											setFormData({ ...formData, email: e.target.value })
										}
									/>
								</div>
								<div className="col-12 mb-3">
									<label>{t("Subject")}</label>
									<input
										type="text"
										required
										value={formData?.subject}
										placeholder={t("Subject")}
										onChange={(e) =>
											setFormData({ ...formData, subject: e.target.value })
										}
									/>
								</div>
								<div className="col-12 mb-3">
									<label>{t("Message")}</label>
									<textarea
										type="text"
										required
										value={formData?.message}
										style={{
											minHeight: "97px",
										}}
										placeholder={t("Message")}
										onChange={(e) =>
											setFormData({ ...formData, message: e.target.value })
										}
									/>
								</div>
								<div className="col-12">
									<button className="submit" type="submit">
										{t("Apply")}
									</button>
								</div>
							</div>
						</form>
						<img src={contactusImg} alt="contactusImg" />
					</div>
					<div className="carrers">
						<p className="title">{t("Careers")}</p>
						<p className="data">
							{t("Forward your Resume to")} <span>{data?.email}</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
export default ContactUs;
